import { render, staticRenderFns } from "./EditarAlertaBaseModal.vue?vue&type=template&id=c72f6536&"
import script from "./EditarAlertaBaseModal.vue?vue&type=script&lang=ts&"
export * from "./EditarAlertaBaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports